// extracted by mini-css-extract-plugin
export default {"card":"card__-M4Rq"};